module.exports = __webpack_public_path__ + "static/media/refresh_top_navbar_icon.20b67d05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refresh_top_navbar_icon.svg
// module id = 443
// module chunks = 1